import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
  { path: 'contactenos', loadChildren: () => import('./contact/contact.module').then(m => m.ContactModule) }, 
  { path: 'sobre-nosotros', loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule) }, 
  { path: 'sucursales', loadChildren: () => import('./branches/branches.module').then(m => m.BranchesModule) }, 
  { path: 'cotizar/:submodelo', loadChildren: () => import('./quoter/quoter.module').then(m => m.QuoterModule) },
  { path: 'cotizar', loadChildren: () => import('./quoter/quoter.module').then(m => m.QuoterModule) },
  { path: ':serie', loadChildren: () => import('./vehicle/vehicle.module').then(m => m.VehicleModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
